import type { IconProps } from '../types/IconProps.ts';
export const Search: IconProps = {
    name: 'Search',
    children: [
        `<circle cx="11" cy="11" r="8" />`,
        `<path d="M16.95 17.05 21 21" />`,
    ]
};